import { useEffect, useState } from 'react';

import PlansScreenAdapter from './PlansScreen/PlansScreenAdapter';
import PaymentMethodsScreenAdapter from './PaymentMethodsScreen/PaymentMethodsScreenAdapter';
import CardFormScreenAdapter from './CardFormScreen/CardFormScreenAdapter';
import SuccessScreen from './SuccessScreen/SuccessScreen';

import { useAppSelector } from '@/store/new-order';
import { STEPS } from '@/store/new-order/stepsSlice';
import { resolveAppSuccessLink, resolvePreiumAppUserLink } from '@/utils/appLinks';
import { getParsedParams } from '@/utils/consts/params';

const StepsSwitch = () => {
  const currentStep = useAppSelector((state) => state.steps.current);

  const [appLink, setAppLink] = useState('clearvpn://go/a/payment_succeeded');
  const [isAppLinkLoading, setIsAppLinkLoading] = useState(false);

  useEffect(() => {
    const appIdetityParam = getParsedParams().APP_IDENTITY;

    if (currentStep === STEPS.successForAppUser) {
      setIsAppLinkLoading(true);
      void resolveAppSuccessLink(appIdetityParam).then((link) => {
        setAppLink(link);
        setIsAppLinkLoading(false);
      });
    } else if (currentStep === STEPS.successForPremiumAppUser) {
      setIsAppLinkLoading(true);
      void resolvePreiumAppUserLink(appIdetityParam).then((link) => {
        setAppLink(link);
        setIsAppLinkLoading(false);
      });
    }
  }, [currentStep]);

  switch (currentStep) {
    case STEPS.plans:
      return <PlansScreenAdapter />;

    case STEPS.paymentMethods:
      return <PaymentMethodsScreenAdapter />;

    case STEPS.cardForm:
      return <CardFormScreenAdapter />;

    case STEPS.success:
      return <SuccessScreen />;

    case STEPS.successWithDownload:
      return <SuccessScreen withDownload />;

    case STEPS.successForAppUser:
    case STEPS.successForPremiumAppUser:
      return <SuccessScreen appLink={appLink} loading={isAppLinkLoading} />;

    default:
      return <h1>🫠</h1>;
  }
};

export default StepsSwitch;
